import React, { Component } from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap'
import { connect } from 'react-redux';
import Axios from 'axios';

class DNSRecords extends Component {
    state = {
        domain: {},
        updateDisabled: true
    }
    componentDidMount() {
        this.getSiteData()
    }

    closeAddDNSRecordModal = () => {
        this.setState({ showAddRecord: false })
    }

    getSiteData = () => {
        Axios.post('/api/domains/get/by/domain', { domain: this.props.domain }).then(req => {
            this.setState({ domain: req.data.domain })
        })
    }
    useBlNameServers = () => {
        Axios.post('/api/domains/use/bl/nameservers', { domain: this.props.domain }).then(req => {
            this.getSiteData()
        })
    }
    useCustomNameServers = () => {
        Axios.post('/api/domains/use/custom/nameservers', { domain: this.props.domain }).then(req => {
            this.getSiteData()
        })
    }
    updateRNS = (value, i) => {
        console.log(value, i)
        if (this.state.domain.hostedZoneId) {
            return
        }
        let test
        if (this.state.domain.registrarNameservers == null) {
            console.log("h")
            test = []
        } else {
            console.log("a")
            test = this.state.domain.registrarNameservers
        }
        test[i] = value;
        let enabled = true
        let valid = true
        for (let t of test) {
            if (t == "") {
                valid = false
                break
            }

            let rv = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(t);
            if (!rv) {
                valid = false
                break
            }
        }


        enabled = !valid;
        console.log(test)
        this.setState({ "domain": { ...this.state.domain, registrarNameservers: test }, updateDisabled: enabled }, () => {
            console.log("after", this.state.domain)
        })


    }
    saveCustomRNs = () => {
        Axios.post('/api/domains/add/custom/nameservers', { rns: this.state.domain.registrarNameservers, domain: this.props.domain }).then(req => {
            this.getSiteData()
        })
    }
    render() {
        let darkmode = this.props.user.darkmode

        let nsHtml = []
        this.state.domain?.registrarNameservers?.forEach((ns, i) => {
            nsHtml.push(<input value={ns} onChange={(e) => { this.updateRNS(e.target.value, i) }} />)
        });
        if (!this.state.domain.hostedZoneId) {
            let len = this.state.domain?.registrarNameservers?.length
            if (len == undefined) {
                len = 0;
            }
            nsHtml.push(<input value={""} onChange={(e) => { this.updateRNS(e.target.value, len) }} />)
        }

        return (
            <div>
                <div className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} style={{ textAlign: 'center', paddingTop: "10px" }}>
                    <div style={{ margin: "auto", textAlign: "center" }}>
                        {nsHtml}
                    </div>
                    {!this.state.domain.hostedZoneId ?
                        <div>
                            <div>
                                <Button disabled={this.state.updateDisabled} className='button-primary' onClick={this.saveCustomRNs} style={{ marginBottom: '10px', width: "50%" }}>Update Nameservers</Button>

                            </div>

                            <Button className='button-primary' onClick={this.useBlNameServers} style={{ marginBottom: '10px', width: "50%" }}>Manage my DNS with BreezeLabs</Button>
                            {this.state.updateDisabled && <p style={{color: "red"}}>Each nameserver must be a valid domain (e.g. ns1.example.com). Minimum of 2 NS required.</p>}
                        </div>
                        :
                        <div>
                            <Button className='button-primary' onClick={this.useCustomNameServers} style={{ marginBottom: '10px', width: "50%" }}>Use custom Nameservers</Button>
                            <div>
                                *By using custom nameservers, BreezeLabs will no longer manage your domains DNS and will be unable to provide any support regarding DNS issues, this responsibility will fall to the relevant company managing your Nameservers.
                            </div>
                        </div>

                    }

                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        subscriptions: state.subscriptions,
        user: state.user
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setSubscriptionsCancelled: (index) => { dispatch(setSubscriptionsCancelled(index)) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DNSRecords);